module.exports = __webpack_public_path__ + "img/cass-logo-white.eb44ee72.svg";